<template>
  <div class="stance-selector col-12">
    <div class="row">
      <div class="col-6 mb-2 pl-1 pr-1" v-for="(stance,idx) in stances" :key="idx" @click="stanceSelected(stance)">
        <Stance :stance="stance" :activeSpell="activeSpell" :activeStance="activeStance"
                @selected="stanceSelected" @spell="stanceSpell"></Stance>
      </div>
    </div>
  </div>
</template>

<script>
  import Stance from "./Stance";

  export default {
    name: "StanceSelector",
    components: {Stance},
    props: {
      activeStance: {
        type: Object,
        default: function () {
          return null;
        },
      },
      activeSpell: {
        type: Object,
        default: function () {
          return null;
        }
      },
      stances: {
        type: Array,
        default: function () {
          return [{
            attack_style: null,
            attack_type: null,
            boosts: "accuracy and damage",
            combat_style: "accurate",
            experience: "magic",
          }
          ]
        }
      }
    },
    methods: {
      stanceSelected(stance) {
        console.log('Stance selected', stance);

        if(stance.attack_style === 'magic') {
          this.$emit('stanceSpell')
        }

        this.$emit('selected', stance);
      },

      stanceSpell() {
        this.$emit('stanceSpell');
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/gear-selector/StanceSelector.vue